import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export class CameraController {
  readonly controls: OrbitControls;
  private homePosition = new THREE.Vector3(15, 15, 18);
  private homeTarget = new THREE.Vector3(0, 0, 0);
  private positionGoal = this.homePosition.clone();
  private targetGoal = this.homeTarget.clone();
  private focusing = false;

  constructor(camera: THREE.PerspectiveCamera, dom: HTMLElement) {
    this.controls = new OrbitControls(camera, dom);
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.075;
    this.controls.minDistance = 9;
    this.controls.maxDistance = 36;
    this.controls.minPolarAngle = 0.22;
    this.controls.maxPolarAngle = Math.PI / 2.06;
    this.controls.target.copy(this.homeTarget);
    this.controls.mouseButtons = {
      LEFT: THREE.MOUSE.ROTATE,
      MIDDLE: THREE.MOUSE.DOLLY,
      RIGHT: THREE.MOUSE.PAN
    };
  }

  focus(object: THREE.Object3D, camera: THREE.PerspectiveCamera): void {
    const box = new THREE.Box3().setFromObject(object);
    const center = box.getCenter(new THREE.Vector3());
    this.targetGoal.copy(center);
    this.positionGoal.copy(center).add(new THREE.Vector3(5.5, 5.8, 7));
    this.focusing = true;
    this.controls.enabled = false;
    void camera;
  }

  reset(): void {
    this.positionGoal.copy(this.homePosition);
    this.targetGoal.copy(this.homeTarget);
    this.focusing = true;
    this.controls.enabled = false;
  }

  update(camera: THREE.PerspectiveCamera): void {
    if (this.focusing) {
      camera.position.lerp(this.positionGoal, 0.085);
      this.controls.target.lerp(this.targetGoal, 0.085);
      if (camera.position.distanceTo(this.positionGoal) < 0.08 && this.controls.target.distanceTo(this.targetGoal) < 0.04) {
        this.focusing = false;
        this.controls.enabled = true;
      }
    }
    this.controls.update();
  }

  dispose(): void {
    this.controls.dispose();
  }
}
